import React from 'react';
import Router from './shared/router';

const App = () => {
  return <Router />;
};

export default App;
